class FaqAnchor extends HTMLElement {
    connectedCallback () {
        this.buttons = this.querySelectorAll('[data-target]');
        this.categories = document.querySelectorAll('[data-faq-category]');

        this.buttons.forEach((button) => {
            button.addEventListener('click', () => {
                this.onClick(button);
            });
        });
    }

    onClick (activeButton) {
        const targetValue = activeButton.dataset.target;

        // Update buttons state
        this.buttons.forEach((button) => {
            const isActive = button === activeButton;
            button.classList.toggle('is-active', isActive);
            button.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        });

        // First hide everything
        this.categories.forEach((category) => {
            category.hidden = true;

            let el = category.nextElementSibling;
            while (el && !el.hasAttribute('data-faq-category')) {
                el.hidden = true;
                el = el.nextElementSibling;
            }
        });

        // Then show the selected category + its accordions
        const activeCategory = document.querySelector(
            `[data-faq-category="${targetValue}"]`
        );

        if (!activeCategory) return;

        activeCategory.hidden = false;

        let el = activeCategory.nextElementSibling;
        while (el && !el.hasAttribute('data-faq-category')) {
            el.hidden = false;
            el = el.nextElementSibling;
        }
    }
}

customElements.define('faq-anchor', FaqAnchor);